import { useEffect, useRef } from 'react'

/**
 * Opens a centered OAuth popup for `url` and polls until it closes, then
 * fires `onSuccess`. Extracted (unchanged) from ChatIntegrations.jsx so it
 * can be shared by other integration cards (e.g. ZaloZbsCard) without
 * duplicating the popup/poll logic.
 */
export function useOAuthPopup(url, onSuccess) {
  const popupRef = useRef(null)
  const timerRef = useRef(null)

  function open() {
    const w = 520, h = 620
    const left = window.screenX + (window.outerWidth - w) / 2
    const top  = window.screenY + (window.outerHeight - h) / 2
    popupRef.current = window.open(url, 'zalo_oauth', `width=${w},height=${h},left=${left},top=${top}`)

    timerRef.current = setInterval(() => {
      if (popupRef.current && popupRef.current.closed) {
        clearInterval(timerRef.current)
        onSuccess()
      }
    }, 800)
  }

  useEffect(() => () => clearInterval(timerRef.current), [])
  return open
}
